












export default {
  name: 'BillIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
